import CustomZipcode from "../externals/zipcode";

let $error = $("<label class='error error_address_lookup order-0'></label>")
$error.html('We konden uw combinatie van postcode en huisnummer niet vinden. Klopt deze wél? Ga dan verder.');

$('[data-form-zipcode="scope"]').each((index, scope) => {
	new CustomZipcode($(scope), {
		scope: '[data-form-zipcode="scope"]',
		zipcodeSelector: '[data-form-zipcode="zipcode"]',
		streetSelector: '[data-form-zipcode="street"]',
		streetNumberSelector: '[data-form-zipcode="street_number"]',
		townSelector: '[data-form-zipcode="town"]',
		countrySelector: '[data-form-zipcode="country"]',
		errorElem: $error
	});
})


